{
  "de": {
    "incognito": {
      "signedInAs": "Angemeldet als",
      "stop": "Beenden"
    }
  }
}
